import './firebase';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './ThemeProvider';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap has pre-rendered HTML, hydrate it; otherwise render fresh
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
} 